/** Keep EUR symbols after amounts in Finnish storefront text, including app updates. */
export function finnishEuroText(value) {
  return value.replace(/€[\s\u00a0\u202f]*(\d+(?:[.,\u00a0\u202f ]\d{3})*(?:[.,]\d{1,2})?)/g, '$1\u00a0€');
}

export function compactEuroText(value) {
  return value
    .replace(/(\d)[.,]00(?=[\s\u00a0\u202f]*€)/g, '$1')
    .replace(/(€[\s\u00a0\u202f]*(?:\d{1,3}(?:[.,\u00a0\u202f ]\d{3})+|\d+))[.,]00(?!\d)/g, '$1');
}

const finnish = typeof document !== 'undefined' && document.documentElement.lang.toLowerCase().split('-')[0] === 'fi';
const ignored = 'script, style, textarea, code, pre, svg, [contenteditable="true"], [data-arc-preserve-money]';
function normalize(node) {
  if (node.nodeType === Node.TEXT_NODE) {
    if (!node.parentElement || node.parentElement.closest(ignored)) return;
    const value = node.nodeValue ?? '';
    const next = compactEuroText(finnish ? finnishEuroText(value) : value);
    if (next !== node.nodeValue) node.nodeValue = next;
    return;
  }
  if (node.nodeType !== Node.ELEMENT_NODE || node.matches(ignored)) return;
  const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
  let text;
  while ((text = walker.nextNode())) normalize(text);
}

if (typeof document !== 'undefined') {
  normalize(document.body);
  const observer = new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'characterData') normalize(record.target);
      else for (const node of record.addedNodes) normalize(node);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
}
